import { Injectable, inject } from '@angular/core';
import { HttpService } from './http.service';
import { RepositoryService } from '../baseServices/repository.service';
import { FlexFormsEndpoints, MobileEndpoints, BlobStorageEndpoints, UserEndpoints } from '../constant/API-endpoints-constants';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  protected MOBILE_API_ENDPOINTS = MobileEndpoints;
  protected USER_API_ENDPOINTS = UserEndpoints;
  protected FLEX_FORMS_API_ENDPOINTS = FlexFormsEndpoints;
  protected BLOB_STORAGE_ENDPOINTS = BlobStorageEndpoints;

  protected http: HttpService = inject(HttpService);
  protected repository: RepositoryService = inject(RepositoryService);

  constructor() {}
}
